import { SOCKET_EVENTS } from '@constants';
import { ISocketUser } from '@sdk/contracts';
import { useCallback, useEffect } from 'react';

import { useSocket, useSocketUsers } from '@/hooks';

export const OnlineUsersHandler = () => {
  const { setSocketUser } = useSocketUsers();
  const { on, off } = useSocket();

  const handleSetOnlineUsers = useCallback(
    (users: ISocketUser[]) => {
      setSocketUser(users);
    },
    [setSocketUser]
  );

  useEffect(() => {
    on(SOCKET_EVENTS.CONNECTED_USERS, handleSetOnlineUsers);
    return () => {
      off(SOCKET_EVENTS.CONNECTED_USERS, handleSetOnlineUsers);
    };
  }, [handleSetOnlineUsers, off, on]);

  return null;
};
